export interface Character {
  id: string;
  name: string;
  alias: string;
  role: string;
  tagline: string;
  age: string;
  height: string;
  hobby: string;
  color: string;
  intro: string;
  traits: string[];
  image: string;
}

export const femaleLead: Character = {
  id: 'female-lead',
  name: '夏目 铃音',
  alias: '小铃 / Gyaru Queen',
  role: '女主角 · 寄宿的辣妹',
  tagline: '看似张扬，实则藏着温柔的秘密',
  age: '17岁',
  height: '168cm',
  hobby: '美甲、街头穿搭、听J-POP',
  color: '珊瑚橙',
  intro:
    '铃音是故事中那个突然住进男主家的辣妹，留着金棕色的长卷发，总是画着精致的妆容、踩着厚底鞋。她外表大大咧咧、爱开玩笑，让人第一眼觉得她只是个爱玩爱闹的活泼女孩。可随着相处深入，你会慢慢发现她细腻敏感的一面——她会记住男主随口说过的一句喜好，也会在没人注意的角落默默为他打气。',
  traits: ['元气满满', '外冷内热', '行动力超强', '刀子嘴豆腐心'],
  image:
    'https://readdy.ai/api/search-image?query=anime%20gyaru%20girl%20portrait%20with%20long%20golden%20blonde%20curly%20hair%2C%20fresh%20makeup%2C%20denim%20jacket%20and%20neon%20pink%20top%2C%20confident%20smile%2C%20warm%20cream%20studio%20background%2C%20vibrant%20coral%20and%20gold%20lighting%2C%20high%20detail%20illustration&width=800&height=1000&seq=gal-female-lead&orientation=portrait',
};

export const maleLead: Character = {
  id: 'male-lead',
  name: '水无月 遥',
  alias: '小遥 / 宅家少年',
  role: '男主角 · 沉默的寄主',
  tagline: '安静内敛的独居少年，生活被彻底搅动',
  age: '17岁',
  height: '176cm',
  hobby: '游戏、漫画、摄影',
  color: '暖棕色',
  intro:
    '遥是一个习惯独处的安静少年，父母常年出差，一个人守着偌大的公寓。他性格内敛、不善表达，喜欢把所有情绪都藏在心里。某天表妹铃音因故借住到他家，从此他平静的生活被彻底打乱——从抗拒、尴尬，到逐渐被这个活力满满的女孩带动起来，学会打开心门。',
  traits: ['内敛温柔', '观察力强', '闷骚', '有责任心'],
  image:
    'https://readdy.ai/api/search-image?query=anime%20boy%20portrait%20with%20messy%20dark%20brown%20hair%2C%20wearing%20loose%20hoodie%20and%20glasses%2C%20gentle%20shy%20smile%2C%20warm%20cream%20background%2C%20soft%20coral%20and%20brown%20tones%2C%20high%20detail%20illustration&width=800&height=1000&seq=gal-male-lead&orientation=portrait',
};

export const sideCharacters: Character[] = [
  {
    id: 'rin',
    name: '天城 凛',
    alias: '凛姐',
    role: '铃音的同校挚友',
    tagline: '行走的时尚教科书，最会助攻的闺蜜',
    age: '17岁',
    height: '163cm',
    hobby: '穿搭博主、逛街',
    color: '蜜桃粉',
    intro:
      '凛是铃音的多年好友，同样是个穿搭精致的辣妹，但性格更冷静、更有分寸感。她总能在铃音冲动时拉她一把，也会不动声色地给遥和铃音制造独处的机会，堪称全剧最靠谱的助攻担当。',
    traits: ['冷静', '讲义气', '时尚达人', '神助攻'],
    image:
      'https://readdy.ai/api/search-image?query=anime%20gyaru%20girl%20portrait%20with%20short%20pink%20bob%20hair%2C%20fashionable%20streetwear%20outfit%2C%20stylish%20and%20calm%20expression%2C%20warm%20cream%20background%2C%20soft%20peach%20lighting%2C%20high%20detail%20illustration&width=600&height=700&seq=gal-rin&orientation=portrait',
  },
  {
    id: 'aoi',
    name: '青井 葵',
    alias: '阿葵',
    role: '遥的青梅竹马',
    tagline: '温柔细心的邻家女孩，夹在两人之间',
    age: '17岁',
    height: '158cm',
    hobby: '烘焙、手作、读书',
    color: '奶油黄',
    intro:
      '葵是和遥一起长大的青梅竹马，性格温婉体贴，是典型的老好人。她一直暗恋着遥，却总把心思藏在温柔的笑容里。铃音的出现让她内心泛起波澜，也让这段关系变得微妙又复杂。',
    traits: ['温柔', '善解人意', '暗恋', '心思细腻'],
    image:
      'https://readdy.ai/api/search-image?query=anime%20girl%20portrait%20with%20long%20soft%20cream%20yellow%20hair%2C%20gentle%20sweet%20smile%2C%20knitted%20cardigan%20and%20dress%2C%20warm%20cream%20background%2C%20soft%20golden%20lighting%2C%20high%20detail%20illustration&width=600&height=700&seq=gal-aoi&orientation=portrait',
  },
  {
    id: 'yuki',
    name: '如月 优纪',
    alias: '优纪学长',
    role: '遥的室友兼损友',
    tagline: '人形吐槽机，全剧的笑点担当',
    age: '18岁',
    height: '182cm',
    hobby: '篮球、看热闹',
    color: '焦糖棕',
    intro:
      '优纪是遥的室友，也是学校里小有名气的篮球手。他性格开朗爱闹，最大的乐趣就是看遥被铃音折腾得手足无措。虽然总爱起哄，但关键时刻也是最讲义气的朋友。',
    traits: ['开朗', '毒舌', '义气', '气氛担当'],
    image:
      'https://readdy.ai/api/search-image?query=anime%20boy%20portrait%20with%20short%20brown%20hair%20and%20sunny%20grin%2C%20sporty%20basketball%20jersey%2C%20energetic%20playful%20expression%2C%20warm%20cream%20background%2C%20soft%20caramel%20lighting%2C%20high%20detail%20illustration&width=600&height=700&seq=gal-yuki&orientation=portrait',
  },
];

export interface RelationEdge {
  from: string;
  to: string;
  label: string;
  type: 'romance' | 'friend' | 'family' | 'rival';
}

export interface RelationNode {
  id: string;
  name: string;
  role: string;
  x: number;
  y: number;
}

export const relationNodes: RelationNode[] = [
  { id: 'female-lead', name: '铃音', role: '寄宿辣妹 · 女主', x: 50, y: 16 },
  { id: 'male-lead', name: '遥', role: '宅家少年 · 男主', x: 50, y: 60 },
  { id: 'rin', name: '凛', role: '铃音挚友', x: 8, y: 32 },
  { id: 'aoi', name: '葵', role: '遥的青梅竹马', x: 92, y: 32 },
  { id: 'yuki', name: '优纪', role: '遥的室友', x: 92, y: 70 },
];

export const relationEdges: RelationEdge[] = [
  { from: 'female-lead', to: 'male-lead', label: '寄宿·暧昧', type: 'romance' },
  { from: 'rin', to: 'female-lead', label: '挚友·助攻', type: 'friend' },
  { from: 'aoi', to: 'male-lead', label: '青梅竹马', type: 'family' },
  { from: 'yuki', to: 'male-lead', label: '室友·损友', type: 'friend' },
  { from: 'aoi', to: 'female-lead', label: '情愫·纠结', type: 'rival' },
  { from: 'rin', to: 'yuki', label: '欢喜冤家', type: 'friend' },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '泡在我家的辣妹的女主角到底是谁？',
    a: '女主角是夏目铃音，一个因为家庭原因暂时借住在男主家的辣妹女孩。她性格张扬外向、元气满满，是推动整个故事发展的核心角色。想知道她更多背景和设定，可以查看上方的「女主是谁」角色介绍。',
  },
  {
    q: '男主角水无月遥是一个什么样的人？',
    a: '男主角水无月遥是一个性格内敛、习惯独处的安静少年。他父母常年出差，独自守着一间大公寓，直到表妹铃音搬进来后，他的生活才被彻底改变。他的成长线与情感变化是故事的一条重要主线。',
  },
  {
    q: '泡在我家的辣妹人物关系复杂吗？容易看懂吗？',
    a: '并不复杂，核心关系就是铃音与遥之间的寄宿与情感主线，另外还有凛、葵、优纪等几个性格鲜明的角色作为支线点缀。我们在「人物关系」板块用一张清晰的关系图帮你理清谁和谁是什么关系，一图入坑。',
  },
  {
    q: '铃音和遥之间到底是什么关系？',
    a: '铃音是遥的表妹，因为家庭原因暂时借住在他家。两人从最初的生疏、尴尬，到逐渐熟悉、互相影响，感情线也在日复一日的相处中悄然升温，是全剧最让人上头的地方。',
  },
  {
    q: '除了男女主，还有哪些值得关注的角色？',
    a: '还有铃音的挚友凛、遥的青梅竹马葵、以及遥的室友优纪。这三个角色性格鲜明、各有看点，也让主角团的关系网更加丰满有趣。你可以在「角色图鉴」里快速了解每一个人。',
  },
  {
    q: '这个网站能提供完整的剧情和最新更新吗？',
    a: '本站聚焦于角色介绍、人物关系梳理和入坑指南，让你快速了解主要角色的设定与互动。关于具体章节剧情与更新进度，建议前往作品官方平台查阅，以获得最权威的信息。',
  },
];

export const reviews = [
  {
    name: '奶茶加冰',
    role: '入坑一个月的新人',
    text: '本来只是刷到片段好奇进来看看，结果把人物关系一捋就上头了。铃音这个角色真的越看越喜欢，外表辣妹内心柔软，反差感拉满。',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20flat%20illustration%20avatar%20of%20a%20smiling%20girl%20with%20pink%20hair%2C%20minimal%20coral%20background%2C%20cute%20round%20face&width=200&height=200&seq=gal-avatar-1&orientation=squarish',
  },
  {
    name: '熬夜追番人',
    role: '老二次元',
    text: '人物关系图画得特别清楚，谁和谁是什么关系一目了然。角色图鉴里的图也很精致，收藏了好几张当壁纸。',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20flat%20illustration%20avatar%20of%20a%20boy%20with%20brown%20hair%20wearing%20glasses%2C%20minimal%20cream%20background%2C%20cute%20round%20face&width=200&height=200&seq=gal-avatar-2&orientation=squarish',
  },
  {
    name: '浅予',
    role: '铃音粉头',
    text: '女主是谁这个板块做得太到位了，性格、喜好、人设细节全都有，对新手特别友好。强烈安利给想入坑的朋友！',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20flat%20illustration%20avatar%20of%20a%20cheerful%20girl%20with%20blonde%20hair%2C%20minimal%20peach%20background%2C%20cute%20round%20face&width=200&height=200&seq=gal-avatar-3&orientation=squarish',
  },
];